// Конфигурация пагинации для таблиц

// Опции пагинации для всех таблиц
export const PAGINATION_OPTIONS = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' }
];

// Стандартное значение по умолчанию
export const DEFAULT_PAGE_SIZE = 10;

// Максимальный размер страницы
export const MAX_PAGE_SIZE = 100;

// Константы для каталога
export const CATALOG_ITEMS_PER_PAGE = 10;